import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPeopleAdd2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPeopleAdd2"><Path d="M5.50073 6.5C5.50073 4.01472 7.51545 2 10.0007 2C12.486 2 14.5007 4.01472 14.5007 6.5C14.5007 8.98528 12.486 11 10.0007 11C7.51545 11 5.50073 8.98528 5.50073 6.5Z" fill="currentColor"/><Path d="M1.50515 19.9064C1.91741 15.5211 5.24298 12 10.0008 12C14.7585 12 18.0841 15.5211 18.4964 19.9064L18.5992 21H1.40234L1.50515 19.9064Z" fill="currentColor"/><Path d="M20.0007 10V7H18.0007V10H15.0007V12H18.0007V15H20.0007V12H23.0007V10H20.0007Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPeopleAdd2;
